import { useParams, useNavigate } from 'react-router-dom';
import { useState, useEffect, useMemo } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import StructuredData from '@/components/feature/StructuredData';
import { articles, categories } from '@/mocks/articles';

function getCategoryImage(slug: string): string {
  if (slug === 'wanghong-fanche') return 'https://readdy.ai/api/search-image?query=Dramatic%20scene%20of%20social%20media%20influencer%20with%20mask%20falling%20off%20revealing%20hidden%20truth%2C%20split%20personality%20concept%2C%20moody%20pink%20and%20cyan%20neon%20lighting%2C%20cinematic%20composition%2C%20dark%20atmospheric%20background%20with%20digital%20glitch%20effects%2C%20editorial%20photography%20style&width=800&height=500&seq=cat-wanghong&orientation=landscape';
  if (slug === 'mingxing-bagua') return 'https://readdy.ai/api/search-image?query=Paparazzi%20photography%20scene%20at%20night%20with%20camera%20flash%20and%20red%20carpet%2C%20celebrity%20silhouette%20behind%20frosted%20glass%2C%20dramatic%20noir%20lighting%2C%20Hollywood%20glamour%20meets%20dark%20mystery%2C%20cinematic%20wide%20shot%2C%20editorial%20style%20with%20deep%20shadows&width=800&height=500&seq=cat-mingxing&orientation=landscape';
  if (slug === 'meiri-dasai') return 'https://readdy.ai/api/search-image?query=Competition%20stage%20with%20dramatic%20spotlight%20beams%20and%20trophy%20in%20center%2C%20intense%20athletic%20rivalry%20atmosphere%2C%20sports%20documentary%20style%2C%20moody%20dramatic%20lighting%20with%20cyan%20and%20amber%20accents%2C%20dark%20stadium%20background%20with%20cheering%20crowd%20silhouettes&width=800&height=500&seq=cat-meiri&orientation=landscape';
  if (slug === 'fancha-shipin') return 'https://readdy.ai/api/search-image?query=Split%20screen%20comparison%20showing%20glamorous%20vs%20natural%2C%20before%20and%20after%20concept%2C%20dramatic%20contrast%20lighting%2C%20beauty%20and%20reality%20theme%2C%20moody%20pink%20and%20cyan%20split%20lighting%2C%20editorial%20photography%2C%20dark%20studio%20background&width=800&height=500&seq=cat-fancha&orientation=landscape';
  if (slug === 'zuixin-dagua') return 'https://readdy.ai/api/search-image?query=Explosive%20breaking%20news%20concept%20with%20dramatic%20red%20emergency%20lights%2C%20newspaper%20headlines%20swirling%20in%20digital%20vortex%2C%20urgent%20atmosphere%2C%20cyberpunk%20newsroom%20aesthetic%2C%20cinematic%20composition%20with%20intense%20energy%2C%20dark%20background%20with%20fiery%20accents&width=800&height=500&seq=cat-zuixin&orientation=landscape';
  if (slug === 'heise-changshi') return 'https://readdy.ai/api/search-image?query=Detective%20investigation%20scene%20with%20evidence%20board%20and%20red%20string%20connections%2C%20magnifying%20glass%20over%20documents%2C%20mysterious%20noir%20atmosphere%2C%20dramatic%20single%20spotlight%2C%20crime%20documentary%20style%2C%20dark%20background%20with%20subtle%20texture&width=800&height=500&seq=cat-heise&orientation=landscape';
  return 'https://readdy.ai/api/search-image?query=Dark%20moody%20breaking%20news%20background%20with%20dramatic%20lighting%2C%20abstract%20newsroom%20concept%2C%20pink%20and%20cyan%20neon%20accents%2C%20editorial%20atmosphere%2C%20clean%20dark%20background&width=800&height=500&seq=cat-fallback&orientation=landscape';
}

function getArticleImage(id: number): string {
  if (id === 1) return 'https://readdy.ai/api/search-image?query=Dramatic%20scene%20of%20a%20livestream%20setup%20with%20neon%20ring%20light%20falling%20over%2C%20shattered%20makeup%20products%20on%20a%20dark%20floor%2C%20dim%20moody%20lighting%20with%20pink%20and%20cyan%20accents%2C%20cinematic%20composition%2C%20editorial%20photography%20style%20with%20deep%20shadows%20and%20moody%20atmosphere%2C%20simple%20dark%20background&width=800&height=500&seq=cat-article-1&orientation=landscape';
  if (id === 2) return 'https://readdy.ai/api/search-image?query=Luxury%20hotel%20entrance%20at%20night%20with%20paparazzi%20camera%20flash%20effect%2C%20sleek%20black%20car%20pulling%20up%2C%20dramatic%20noir%20lighting%20with%20neon%20city%20reflections%2C%20cinematic%20wide%20shot%2C%20editorial%20photography%20with%20deep%20contrast%20and%20moody%20atmosphere%2C%20dark%20urban%20background&width=800&height=500&seq=cat-article-2&orientation=landscape';
  if (id === 3) return 'https://readdy.ai/api/search-image?query=TV%20studio%20set%20with%20dramatic%20red%20and%20blue%20lighting%2C%20two%20silhouettes%20confronting%20each%20other%20on%20stage%2C%20cameras%20and%20crew%20in%20background%20blurred%2C%20intense%20atmosphere%20with%20spotlight%20beams%20cutting%20through%20haze%2C%20cinematic%20documentary%20style%2C%20dark%20studio%20background&width=800&height=500&seq=cat-article-3&orientation=landscape';
  if (id === 4) return 'https://readdy.ai/api/search-image?query=Split%20composition%20showing%20glamorous%20editorial%20beauty%20portrait%20on%20one%20side%20and%20casual%20natural%20candid%20on%20the%20other%2C%20dramatic%20lighting%20contrast%2C%20fashion%20magazine%20style%20meets%20street%20photography%2C%20moody%20atmospheric%20tones%2C%20dark%20simple%20background%20with%20spotlight%20effect&width=800&height=500&seq=cat-article-4&orientation=landscape';
  if (id === 5) return 'https://readdy.ai/api/search-image?query=Corporate%20office%20building%20at%20night%20with%20lights%20flickering%20dramatically%2C%20stock%20market%20charts%20showing%20sharp%20decline%20on%20dark%20screens%2C%20emergency%20documents%20scattered%20on%20desk%2C%20noir%20thriller%20atmosphere%20with%20cyan%20and%20red%20accent%20lighting%2C%20cinematic%20composition%2C%20dark%20corporate%20environment&width=800&height=500&seq=cat-article-5&orientation=landscape';
  if (id === 6) return 'https://readdy.ai/api/search-image?query=Two%20smartphones%20facing%20each%20other%20on%20a%20dark%20reflective%20surface%20with%20broken%20heart%20neon%20sign%20reflection%2C%20shattered%20glass%20effect%2C%20messy%20breakup%20atmosphere%20with%20scattered%20polaroid%20photos%2C%20moody%20pink%20and%20cyan%20lighting%2C%20editorial%20still%20life%20photography%2C%20dark%20background&width=800&height=500&seq=cat-article-6&orientation=landscape';
  if (id === 7) return 'https://readdy.ai/api/search-image?query=Dark%20control%20room%20with%20multiple%20monitors%20showing%20voting%20data%20and%20graphs%2C%20dramatic%20spotlight%20on%20a%20single%20desk%20with%20scattered%20papers%2C%20mysterious%20surveillance%20atmosphere%2C%20cinematic%20thriller%20lighting%20with%20red%20accent%2C%20dark%20technical%20environment&width=800&height=500&seq=cat-article-7&orientation=landscape';
  if (id === 8) return 'https://readdy.ai/api/search-image?query=Music%20studio%20with%20sheet%20music%20and%20audio%20waveform%20comparison%20on%20dual%20monitors%2C%20dramatic%20split%20lighting%20showing%20original%20vs%20copy%2C%20vinyl%20records%20scattered%20on%20dark%20desk%2C%20moody%20atmosphere%20with%20cyan%20and%20amber%20accent%20lighting%2C%20editorial%20music%20documentary%20style&width=800&height=500&seq=cat-article-8&orientation=landscape';
  if (id === 9) return 'https://readdy.ai/api/search-image?query=Cosmetic%20products%20scattered%20on%20a%20laboratory%20testing%20table%20with%20microscope%20and%20chemical%20analysis%20equipment%2C%20dramatic%20lighting%20with%20test%20tube%20glow%2C%20investigation%20atmosphere%2C%20editorial%20product%20photography%20with%20moody%20shadows%2C%20dark%20scientific%20background&width=800&height=500&seq=cat-article-9&orientation=landscape';
  return 'https://readdy.ai/api/search-image?query=Dark%20moody%20news%20photography%20scene%20with%20dramatic%20lighting%2C%20abstract%20composition%20with%20pink%20and%20cyan%20neon%20accents%2C%20editorial%20atmosphere%2C%20clean%20dark%20background%20with%20subtle%20texture&width=800&height=500&seq=cat-article-fallback&orientation=landscape';
}

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  const [sort, setSort] = useState<'latest' | 'hot'>('latest');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug, sort]);

  const category = categories.find((c) => c.slug === slug);

  const categoryArticles = useMemo(() => {
    const list = articles.filter((a) => a.category === slug);
    if (sort === 'hot') {
      return [...list].sort((a, b) => b.views - a.views);
    }
    return [...list].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
  }, [slug, sort]);

  if (!category) {
    return (
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-20 pb-20 text-center">
          <div className="w-16 h-16 rounded-full bg-background-200 flex items-center justify-center mx-auto mb-4">
            <i className="ri-emotion-sad-line text-2xl text-foreground-400"></i>
          </div>
          <h1 className="text-xl font-heading font-bold text-foreground-50 mb-2">分类不存在</h1>
          <p className="text-foreground-400 mb-6">你查找的分类页面不存在或已被移除</p>
          <button
            onClick={() => navigate('/')}
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-foreground-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-home-line"></i>
            返回首页
          </button>
        </main>
        <Footer />
      </div>
    );
  }

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.911baoliao.com/' },
      { '@type': 'ListItem', position: 2, name: category.name, item: `https://www.911baoliao.com/category/${slug}` },
    ],
  };

  return (
    <>
      <StructuredData data={breadcrumbSchema} />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <section className="relative w-full h-[280px] md:h-[360px] overflow-hidden">
            <img
              src={getCategoryImage(slug || '')}
              alt={category.name}
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/60 to-black/75"></div>
            <div className="relative z-10 w-full h-full max-w-7xl mx-auto px-4 md:px-6 flex flex-col justify-center">
              <div className="max-w-2xl">
                <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-50 mb-3">
                  {category.name}
                </h1>
                <p className="text-sm md:text-base text-foreground-300 leading-relaxed">
                  {category.description}
                </p>
              </div>
            </div>
          </section>

          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: category.name },
              ]}
            />
          </div>

          <section className="py-10 md:py-14">
            <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
              <div className="flex items-center justify-between mb-8">
                <p className="text-sm text-foreground-400 whitespace-nowrap">
                  共 <strong className="text-foreground-50">{categoryArticles.length}</strong> 篇文章
                </p>
                <div className="flex items-center gap-2">
                  <button
                    onClick={() => setSort('latest')}
                    className={`px-3 py-1.5 rounded-full text-xs font-medium whitespace-nowrap cursor-pointer transition-colors ${
                      sort === 'latest'
                        ? 'bg-primary-500 text-foreground-50'
                        : 'bg-background-200 text-foreground-400 hover:bg-background-300'
                    }`}
                  >
                    最新
                  </button>
                  <button
                    onClick={() => setSort('hot')}
                    className={`px-3 py-1.5 rounded-full text-xs font-medium whitespace-nowrap cursor-pointer transition-colors ${
                      sort === 'hot'
                        ? 'bg-primary-500 text-foreground-50'
                        : 'bg-background-200 text-foreground-400 hover:bg-background-300'
                    }`}
                  >
                    最热
                  </button>
                </div>
              </div>

              {categoryArticles.length === 0 ? (
                <div className="text-center py-20">
                  <div className="w-14 h-14 rounded-full bg-background-200 flex items-center justify-center mx-auto mb-4">
                    <i className="ri-file-search-line text-xl text-foreground-400"></i>
                  </div>
                  <p className="text-foreground-400">该分类下暂无文章</p>
                </div>
              ) : (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                  {categoryArticles.map((article, index) => (
                    <article key={article.id} className="group bg-background-200 border border-background-300 rounded-2xl overflow-hidden transition-all duration-300 hover:bg-background-300 hover:border-background-400">
                      <a
                        href={`/article/${article.id}`}
                        onClick={(e) => { e.preventDefault(); navigate(`/article/${article.id}`); }}
                        className="block cursor-pointer"
                      >
                        <div className="relative aspect-[16/10] overflow-hidden">
                          <img
                            src={getArticleImage(article.id)}
                            alt={article.title}
                            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                            loading={index < 3 ? 'eager' : 'lazy'}
                          />
                          {article.hot && (
                            <div className="absolute top-3 left-3">
                              <span className="px-2.5 py-1 rounded-full bg-primary-500 text-foreground-50 text-xs font-medium whitespace-nowrap">
                                热门
                              </span>
                            </div>
                          )}
                        </div>
                        <div className="p-4 md:p-5">
                          <h3 className="text-base md:text-lg font-heading font-bold text-foreground-50 mb-2 line-clamp-2 leading-snug group-hover:text-primary-400 transition-colors">
                            {article.title}
                          </h3>
                          <p className="text-sm text-foreground-300 line-clamp-2 mb-3">
                            {article.excerpt}
                          </p>
                          <div className="flex items-center justify-between text-xs text-foreground-400">
                            <span className="whitespace-nowrap">{article.date}</span>
                            <span className="flex items-center gap-1 whitespace-nowrap">
                              <i className="ri-chat-3-line"></i>
                              {article.comments.toLocaleString()}
                            </span>
                          </div>
                        </div>
                      </a>
                    </article>
                  ))}
                </div>
              )}

              {categoryArticles.length > 6 && (
                <div className="flex justify-center mt-10">
                  <div className="flex items-center gap-2">
                    <button className="w-9 h-9 rounded-lg bg-background-200 flex items-center justify-center text-foreground-400 text-sm hover:bg-background-300 transition-colors cursor-pointer">
                      <i className="ri-arrow-left-s-line"></i>
                    </button>
                    <button className="w-9 h-9 rounded-lg bg-primary-500 text-foreground-50 text-sm font-medium cursor-pointer">1</button>
                    <button className="w-9 h-9 rounded-lg bg-background-200 text-foreground-400 text-sm hover:bg-background-300 transition-colors cursor-pointer">2</button>
                    <button className="w-9 h-9 rounded-lg bg-background-200 text-foreground-400 text-sm hover:bg-background-300 transition-colors cursor-pointer">3</button>
                    <button className="w-9 h-9 rounded-lg bg-background-200 flex items-center justify-center text-foreground-400 text-sm hover:bg-background-300 transition-colors cursor-pointer">
                      <i className="ri-more-line"></i>
                    </button>
                    <button className="w-9 h-9 rounded-lg bg-background-200 flex items-center justify-center text-foreground-400 text-sm hover:bg-background-300 transition-colors cursor-pointer">
                      <i className="ri-arrow-right-s-line"></i>
                    </button>
                  </div>
                </div>
              )}
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}